/**
 * Authoritative Shared CSV Exporter for Route Making
 * - UTF-8 with BOM (\uFEFF) for Arabic Microsoft Excel compatibility
 * - Full character escaping (quotes, commas, newlines)
 * - Optional metadata header block (key-value summary)
 * - Clean native browser file download
 */

export function exportToCsv({ filename, headers = [], rows = [], metadata = [] }) {
  if (!filename) {
    filename = `export-${new Date().toISOString().slice(0, 10)}.csv`;
  }
  if (!filename.endsWith(".csv")) {
    filename += ".csv";
  }

  // Prepend UTF-8 BOM so Excel opens Arabic correctly
  let csv = "\uFEFF";

  const escapeCell = (val) => {
    if (val === null || val === undefined) {
      return '""';
    }
    const str = String(val);
    // Double any existing quotes and wrap in quotes
    return `"${str.replace(/"/g, '""')}"`;
  };

  // 1. Add metadata section if provided
  if (Array.isArray(metadata) && metadata.length > 0) {
    metadata.forEach((item) => {
      if (item && (item.label || item.value !== undefined)) {
        csv += `${escapeCell(item.label || "")},${escapeCell(item.value !== undefined ? item.value : "")}\r\n`;
      }
    });
    csv += "\r\n"; // Empty separator row
  }

  // 2. Add header row
  if (Array.isArray(headers) && headers.length > 0) {
    csv += headers.map(escapeCell).join(",") + "\r\n";
  }

  // 3. Add data rows
  if (Array.isArray(rows) && rows.length > 0) {
    rows.forEach((row) => {
      if (Array.isArray(row)) {
        csv += row.map(escapeCell).join(",") + "\r\n";
      }
    });
  }

  // 4. Download file in browser
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  if (navigator.msSaveBlob) {
    // IE 10+
    navigator.msSaveBlob(blob, filename);
  } else {
    const link = document.createElement("a");
    if (link.download !== undefined) {
      const url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", filename);
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    }
  }
}
